import { render } from "./STemplate.vue?vue&type=template&id=666c6324"
import script from "./STemplate.vue?vue&type=script&lang=js"
export * from "./STemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__